module.exports = __webpack_public_path__ + "static/media/prod-banner.54655ec7.jpg";